export const JWT_ERROR = 'JWT_ERROR';
